import { render, staticRenderFns } from "./TestMobile.vue?vue&type=template&id=0dc1b3f6"
import script from "./TestMobile.vue?vue&type=script&lang=js"
export * from "./TestMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports